export const transactionManagement = {
  transactionManagement: {
    tabs: {
      player: "Oyuncu Adı/ID ile Ara",
      round: "Tur ID ile Ara",
    },
    columns: {
      username: "Kullanıcı Adı",
      tableStatus: "Masa Durumu",
      playerCards: "Oyuncu Kartları",
      otherPlayerCards: "Diğer Oyuncu Kartları",
      communityCards: "Topluluk Kartları",
      type: "Aksiyon Türü",
      amount: "Miktar",
      phaseTitle: "Oyun Aşaması",
      timestamp: "Zaman Damgası",
      isBetHappened: "Bahis Durumu",
      betsOpen: "Bahis Açık",
      betsClosed: "Bahis Kapalı",
      winner: "Kazanan",
      noWinnerYet: "Henüz kazanan yok",
      noCards: "Kart Yok",
      detail: "Oyun Detayları",
      userAction: {
        PLAYER_FOLD: "PAS",
        PLAYER_CALL: "GÖR",
        PLAYER_SIT: "OTUR",
        PLAYER_CHECK: "BEKLE",
        PLAYER_BET: "BAHİS",
        PLAYER_RAISE: "ARTTIR",
        PLAYER_ALLIN: "HEPSİ",
        BIG_BLINDS_POSTED: "BÜYÜK BLINDS YATIRILDI",
        SMALL_BLINDS_POSTED: "KÜÇÜK BLINDS YATIRILDI",
        PLAYER_LEAVE: "ÇIKIŞ",
      },
      phase: {
        TURN: "DÖNÜŞ",
        RIVER: "RIVER",
        FLOP: "FLOP",
        PRE_FLOP: "PRE-FLOP",
        INIT: "BAŞLANGIÇ",
        SHOWDOWN: "SHOWDOWN",
        DEAL: "DEAL",
      },
    },
    filters: {
      lobbyId: "Lobi",
      lobbyId_placeholder: "Lobi Giriniz",
      lobbyId_required: "Lütfen Lobi Giriniz",
      gameType: "Oyun Türü",
      gameType_placeholder: "Oyun Türü Giriniz",
      gameType_required: "Lütfen Oyun Türü Giriniz",
      tableName: "Masa Adı",
      tableName_placeholder: "Masa Adı Giriniz",
      tableName_required: "Lütfen Masa Adı Giriniz",
      username: "Oyuncu Adı",
      username_placeholder: "Oyuncu Adı Giriniz",
      username_required: "Lütfen Oyuncu Adı Giriniz",
      dateRange: "Başlangıç Zamanı - Bitiş Zamanı",
      dateRange_placeholder: "Başlangıç Zamanı - Bitiş Zamanı Giriniz",
      dateRange_required: "Lütfen Başlangıç Zamanı - Bitiş Zamanı Giriniz",
      gameId: "Tur ID",
      gameId_placeholder: "Tur ID Giriniz",
      gameId_required: "Lütfen Tur ID Giriniz",
      tableName_disabled: "Lütfen önce bir Lobi ve Oyun Türü seçin",
    },
    details: {
      name: "Oyun Adı",
      generalGameInfoHeader: "Genel Oyun Bilgileri",
      gameStateHeader: "Oyun Durumu",
      playerInfoHeader: "Oyuncu Bilgileri",
      lobbyId: "Lobi ID",
      tableId: "Masa ID",
      roundId: "Tur ID",
      gameId: "Oyun ID",
      type: "Tür",
      limitType: "Limit Türü",
      totalSeats: "Toplam Koltuk",
      occupiedSeats: "Dolu Koltuk",
      minPlayers: "Minimum Oyuncu",
      maxBuyIn: "Maksimum Giriş Ücreti",
      minBuyIn: "Minimum Giriş Ücreti",
      phase: "Aşama",
      pot: "Pot",
      blinds: "Blinds",
      lastAction: "Son Aksiyon",
      lastActionAmount: "Son Aksiyon Miktarı",
      currentPlayer: "Sıradaki Oyuncu",
      timeoutDefaultAction: "Zaman Aşımı Aksiyonu",
      serviceFeePercent: "Hizmet Ücreti (%)",
      tipPot: "Bahşiş Potu",
      communityCards: "Topluluk Kartları",
      chips: "Çipler",
      balance: "Bakiye",
      seatIndex: "Koltuk Numarası",
      betAmount: "Bahis Miktarı",
      cards: "Kartlar",
      noCards: "Kart Yok",
      winner: "Kazanan",
      ante: "Ante",
      inProgress: "Oyun Devam Ediyor",
      inProgressTrue: "Evet",
      inProgressFalse: "Hayır",
      isActive: "Masa Aktif",
      isActiveTrue: "Aktif",
      isActiveFalse: "Pasif",
      isBetHappened: "Bahis Yapıldı",
      isBetHappenedTrue: "Evet",
      isBetHappenedFalse: "Hayır",
      isPasswordProtected: "Şifre Korumalı",
      isPasswordProtectedTrue: "Evet",
      isPasswordProtectedFalse: "Hayır",
      lastRaiseAmount: "Son Arttırma Miktarı",
    },
    detailDrawer: {
      roundTransactions: {
        title: "Tur İşlemleri",
        tableInfo: "Masa Bilgileri",
        name: "Masa Adı",
        type: "Masa Türü",
        currency: "Para Birimi",
        blinds: "Büyük Blind - Küçük Blind",
        bbsb: "BB - SB",
        totalSeats: "Toplam Koltuk",
        buyInRange: "Giriş Ücreti Aralığı",
        lobbyId: "Lobi ID",
        roundId: "Tur ID",
        roundInfo: "Tur Bilgileri",
        createdAt: "Tur Başlangıç Tarihi",
        BB: "BB",
        SB: "SB",
        dealer: "Dağıtıcı",
        roundStatus: "Tur Durumu",
        roundPot: "Tur Potu",
        roundWinner: "Tur Kazananı",
        playerSeats: "Tur Oyuncu Koltukları",
        roundTransactions: "Tur İşlemleri",
        username: "Kullanıcı Adı",
        type: "Tür",
        amount: "Miktar",
        combination: "Kombinasyon",
        activityDate: "Aktivite Tarihi",
      },
    },
  },
};
